<template>
  <div class="popup-tourism-background">
    <component :is="$store.state.popupTourism.component"></component>
  </div>
</template>

<script>
import found from '@/components/PopupTourism/Found'

export default {
  components: {
    found
  }
}
</script>

<style lang="scss" scoped>
.popup-tourism {
  &-background {
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.6);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
